import React from 'react'
export default function Button({type, children, icon, onclick,disabled}) {
  return (
    <button disabled={disabled ? true : false} type={type ? type : 'button'} onClick={onclick} style={{"paddingInline":"40px"}} className="btn btn-primary">{icon && <i className={icon}></i>} {children}</button>
  )
}